import useTypedSWR from 'src/components/general/useTypedSWR';
import { MDT_REFRESH_INTERVAL } from 'src/myDayToday/constants';
import { GET_EVENT_CARDS_QUERY } from 'src/myDayToday/queries.gql';

export function useMDTEventCards(providerId: string | undefined) {
  return useTypedSWR(
    [
      GET_EVENT_CARDS_QUERY,
      {
        providerId,
      },
    ],
    {
      keepPreviousData: true,
      refreshInterval: MDT_REFRESH_INTERVAL,
      revalidateIfStale: true,
    },
  );
}
